// src/components/MobileLayout.jsx
import React, { useEffect } from "react";
import MomPanel from "./MomPanel";

const MobileLayout = ({
  primaryRemoteEmail,
  remoteSurfaceRef,
  remoteVideoRef,
  pipPos,
  onPipDragStart,
  isPipHovered,
  setIsPipHovered,
  localPipRef,
  myStream,
  isMicOn,
  isCamOn,
  toggleMyMic,
  toggleMyCam,
  toggleRemoteAudio,
  toggleRemoteVideo,
  isRemoteAudioOn,
  isRemoteVideoOn,
  transcriptDraft,
  setTranscriptDraft,
  mom,
  momLoading,
  momError,
  generateMom,
}) => {
  // 🔁 Bind myStream to PiP video once component is mounted
  useEffect(() => {
    if (myStream && localPipRef.current && localPipRef.current.srcObject !== myStream) {
      localPipRef.current.srcObject = myStream;
    }
  }, [myStream, localPipRef]);

  return (
    <div className="room-mobileWrapper">
      <div className="room-videoCard">
        <div className="room-videoHeader">
          <span className="room-videoTitle">Remote Video</span>
          <span className="room-videoSubTitle">
            {primaryRemoteEmail || "Waiting for participant…"}
          </span>
        </div>

        <div className="room-videoSurface" ref={remoteSurfaceRef}>
          <video
            ref={remoteVideoRef}
            autoPlay
            playsInline
            className="room-videoElement"
          />

          {/* PiP local video */}
          <div
            className="pip-container"
            style={{
              left: pipPos.x,
              top: pipPos.y,
            }}
            onMouseDown={onPipDragStart}
            onTouchStart={onPipDragStart}
            onMouseEnter={() => setIsPipHovered(true)}
            onMouseLeave={() => setIsPipHovered(false)}
          >
            <video
              ref={localPipRef}
              autoPlay
              muted
              playsInline
              className="pip-video"
            />

            <div
              className="pip-controls"
              style={{
                opacity: isPipHovered ? 1 : 0,
              }}
            >
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  toggleMyMic();
                }}
                className={
                  "room-iconBtn " +
                  (isMicOn ? "room-iconBtn--active" : "")
                }
              >
                {isMicOn ? "🎙️" : "🔇"}
              </button>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  toggleMyCam();
                }}
                className={
                  "room-iconBtn " +
                  (isCamOn ? "room-iconBtn--active" : "")
                }
              >
                {isCamOn ? "🎥" : "📷"}
              </button>
            </div>
          </div>
        </div>

        <div className="room-videoControls">
          <button
            onClick={toggleRemoteAudio}
            className={
              "room-controlBtn " +
              (isRemoteAudioOn ? "room-controlBtn--active" : "")
            }
          >
            {isRemoteAudioOn ? "Mute Remote Audio" : "Unmute Remote Audio"}
          </button>
          <button
            onClick={toggleRemoteVideo}
            className={
              "room-controlBtn room-controlBtn--danger " +
              (isRemoteVideoOn ? "room-controlBtn--active" : "")
            }
          >
            {isRemoteVideoOn ? "Hide Remote Video" : "Show Remote Video"}
          </button>
        </div>
      </div>

      <MomPanel
        transcriptDraft={transcriptDraft}
        setTranscriptDraft={setTranscriptDraft}
        mom={mom}
        momLoading={momLoading}
        momError={momError}
        generateMom={generateMom}
      />
    </div>
  );
};

export default MobileLayout;
